import metricsClient from "@/axiosClients/metricsClient";

const downloadResultadosCuestionariosReport = (data) => {
    return metricsClient.post(`/grupo-balint/resultados_cuestionarios`, data, {
        responseType: 'blob'
    });
}

export default {
    downloadResultadosCuestionariosReport
}
